import '../../styles/PrivateLayout/PrivateLayout.css';

import { useEffect }          from 'react';
import { observer }           from 'mobx-react';
import { Layout }             from 'antd';
import { Outlet }             from 'react-router-dom';
import { appStore }           from 'stores/AppStore';
import { privateLayoutStore } from 'stores/index';
import currentSession         from 'utils/currentSession';
import Content                from 'components/PrivateLayout/Content';
import Footer                 from 'components/PrivateLayout/Footer';
import Header                 from 'components/PrivateLayout/Header';
import Sider                  from 'components/PrivateLayout/Sider';
import UserMeModel            from 'models/UserMeModel';
import { messageErrorIntl }   from 'utils/messageIntl';

const PrivateLayout = observer(() => {
  useEffect(() => {
    appStore.switchLanguage(currentSession.user.user_informations.language_preference || 'fr');

    if (!privateLayoutStore.showCollection.isLoaded) {
      privateLayoutStore.fetchData();
    }
  }, []);

  const { user } = currentSession;

  const logout = async () => {
    await currentSession.logout();
    window.location.href = '/login';
  };

  const onSwitchTo = async (locale: string) => {
    const userMe = new UserMeModel();
    userMe.setId(currentSession.user.user_id);

    try {
      await userMe.patch({ languagePreference: locale });

      await currentSession.refresh();
    } catch (error: any) {
      if (error.connectorError.response.status === 404) {
        messageErrorIntl("Erreur ! Veuillez-vous reconnecter.");
      } else {
        messageErrorIntl("Une erreur s'est produite.");
      }
    }
  };

  return (
    <Layout
      style={{
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Sider />

      <Layout
        style={{
          // overflow: 'hidden',
          width: '100%',
        }}
      >
        <Header
          logout={logout}
          onSwitchTo={onSwitchTo}
          user={user}
        />

        <Content>
          <Outlet />
        </Content>

        <Footer />
      </Layout>
    </Layout>
  );
});

export default PrivateLayout;
